// extracted by mini-css-extract-plugin
export default {"base":"IconClose_base__3nvIW","root":"IconClose_root__Qz91Q"};